import React from 'react';

import PropTypes from 'prop-types';

const renderNotifcationCard = {
  FOR_PICKUP: (
    <div className="card card-warning">
      <h4 className="font-semibold text-lg text-yellow-600">
        Waiting for rider to confirm order
      </h4>
      <p className="text-sm text-gray-600">
        Please see the customer order details and click the button below to
        confirm that you accept this order.
      </p>
    </div>
  ),
  IN_TRANSIT: (
    <div className="card card-info">
      <h4 className="font-semibold text-lg text-blue-600">Order Accepted</h4>
      <p className="text-sm text-gray-600">
        Please check the order before clicking{' '}
        <span className="font-semibold">&quot;Complete Delivery&quot;</span>{' '}
        button.
      </p>
    </div>
  ),
  default: null,
};

function Notification({ status }) {
  return renderNotifcationCard[status] || renderNotifcationCard?.default;
}
Notification.defaultProps = {};

Notification.propTypes = {
  status: PropTypes.string.isRequired,
};

export default Notification;
